import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
import imageSchema from '@utils/validate/blocksSchemes/imageSchema';
import imagesWithBlurSchema from '@utils/validate/blocksSchemes/imagesWithBlurSchema';
const productPremiumBlockSchema = Joi.object({
  type: Joi.string().valid('productPremiumBlock').required(),
  code: Joi.string().allow('', null).required(),
  imagesWithBlur: imagesWithBlurSchema.allow('', null),
  blocks: Joi.array().items({
    itemId: Joi.string().required(),
    image: Joi.object({
      image: mediaUrlSchema,
      blur: mediaUrlSchema
    }).required(),
    video: Joi.object({
      thumbnail: Joi.string().allow('', null).required(),
      link: Joi.string().allow('', null).required()
    }),
    product: Joi.allow(null).required(),
    object: Joi.allow(null).required(),
    position: Joi.string().allow('', null).required(),
    variant: Joi.object({
      type: Joi.string().allow('', null),
      descriptionTitle: Joi.string().allow('', null),
      descriptionText: Joi.string().allow('', null),
      descriptionButtonText: Joi.string().allow('', null),
      descriptionButtonUrl: Joi.string().allow('', null),
      productDescriptionButtonText: Joi.string().allow('', null),
      productDescriptionDescription: Joi.string().allow('', null),
      productDescriptionImage: imageSchema.allow(null),
      productDescriptionShowButton: Joi.string().allow('', null),
      productDescriptionTitle: Joi.string().allow('', null)
    }).unknown(true),
    objectType: Joi.allow(null).required()
  }).required(),
  voxboxButton: Joi.bool().allow(null).required()
}).unknown(true);
export default productPremiumBlockSchema;